/**
 * 商品情報編集コンポーネント
 */
export default {
    name: 'guide-list',
    template: '#guidelist_component_template',
    data () {
        return {
        };
    },
    props: {
        guide_steps: {
            key: String,
            required: Boolean,
            title: String
        }
    },
    computed: {
    },
    emits: ['emit-modal-manual'],
};